import { Translation, WafTab } from '@enums';
import i18n from '@translations';
import type { TabItem } from '@types';

export const getWafTabs = (): TabItem[] =>
  [
    {
      key: WafTab.CONFIGURATION,
      name: i18n.t(`${Translation.Configuration}:buttons.waf.configuration`),
    },
    {
      key: WafTab.WAF_RULE_SETS,
      name: i18n.t(`${Translation.Configuration}:buttons.waf.wafRuleSets`),
    },
    {
      key: WafTab.WAF_WHITELIST,
      name: i18n.t(`${Translation.Configuration}:tabs.waf.whiteList`),
    },
  ] as const;
